import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import TabComponent from "../../components/tabs/TabComponent";
import GraphicalView from "../../components/GraphicalView/GraphicalView";
import ScoreCard from "../../components/ScoreCard/ScoreCard";
import ButtonComponent from "../../common/button/button";
import SuperThemes from "../../components/SuperThemes/SuperThemes";
import {
  getProjectDetailsByProjectId,
  getBenchmarkValues,
  saveMetricsOfProject,
  getNormalizedValues,
  getDQScore,
  removeMetricFromProject,
  createUserProjectDQScore,
  updateProject,
  saveAndGetNormalizedValues,
  updateMetricWeights,
} from "../../services/projectService";
import {
  getAllCategories,
  getAllSections,
  getAllMetricsByPlatformId,
  getAllPlatformsBySectionIds,
} from "../../services/userService";
import MultiSelectDropdown from "../../components/MultiSelectDropdown/MultiSelectDropdown";
import "./analytics.scss";
import "./AnalyticsTable.scss";
import { toast } from "react-toastify";
import AnalyticsTable from "./AnalyticsTable";
import KPITable from "./KPITable";
import ComparisionView from "./ComparisionView";
import { useParams } from "react-router-dom";
import { FaInfo } from "react-icons/fa";
import * as XLSX from "xlsx";
import { SECTIONS_ORDER } from "../../config/constants";
import { formatDecimalToFixed2, sortAOABySection } from "../../utils/utils";
import ShareViaEmailDialog from '../../common/ShareViaEmailDialog/ShareViaEmailDialog';

export default function Analytics() {
  const [projectIds, setProjectIds] = useState(1);
  const [projectDetails, setProjectDetails] = useState({});
  const [metrics, setMetrics] = useState([]);
  const { projectId } = useParams();

  const [sectionsList, setSectionsList] = useState([]);
  const [platformsList, setPlatformsList] = useState([]);
  const [addMetricList, setAddMetricList] = useState([]);
  const [selectedSectionsList, setSelectedSectionsList] = useState([]);
  const [selectedPlatformsList, setSelectedPlatformsList] = useState([]);
  const [selectedAddMetricList, setAddSelectedMetricList] = useState([]);

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addMetricLoading, setAddMetricLoading] = useState(false);
  const [dqScoreLoading, setDQScoreLoading] = useState(false);

  const [checkStates, setCheckStates] = useState({});
  const [defaultWeights, setDefaultWeights] = useState({});
  const [equallyDistributedWeight, setEquallyDistributedWeight] = useState(0);
  const [totalWeights, setTotalWeights] = useState(100);
  const [draftMetricWeights, setDraftMetricWeights] = useState({});

  const { userInfo, projectInfo } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [normalizedValue, setNormalizedValue] = useState([]);
  const [uniqueComparisonBrandName, setUniqueComparisonBrandName] = useState(
    []
  );
  const [comparisonData, setComparisonData] = useState([]);

  const [dqScoreValue, setDQScoreValue] = useState([]);

  const [filterCategories, setFilterCategories] = useState([]);
  const [selectedFilterCategories, setSelectedFilterCategories] = useState([]);

  const [filteredComparisonData, setFilteredComparisonData] = useState([]);

  const [compareFilterCategories, setCompareFilterCategories] = useState([]);

  const [filterPlatforms, setFilterPlatforms] = useState([]);
  const [selectedFilterPlatforms, setSelectedFilterPlatforms] = useState([]);

  const [filterSection, setFilterSection] = useState([]);
  const [selectedFilterSection, setSelectedFilterSection] = useState([]);

  const [filterMetrics, setFilterMetrics] = useState([]);
  const [selectedFilterMetrics, setSelectedFilterMetrics] = useState([]);

  const [brandCategoryMap, setBrandCategoryMap] = useState({});

  const [brandFilterOptions, setBrandFilterOptions] = useState([]);

  const [excelClick, setExcelClick] = useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);

  const handleShareViaEmailClick = () => {
    setShareDialogOpen(true);
  };

  const handleCloseShareDialog = () => {
    setShareDialogOpen(false);
  };

  const columns = [
    {
      header: "Quarter",
      accessor: "Quarter",
    },
    { header: "Category", accessor: "Category" },
    { header: "Brands", accessor: "Brands" },
    {
      header: "Digital quotient for brand (DQ)",
      accessor: "Digital quotient for brand (DQ)",
    },
    { header: "Ecom DC Score", accessor: "Ecom DC Score" },
    { header: "Social DC Score", accessor: "Social DC Score" },
    { header: "Paid Marketing DC Score", accessor: "Paid Marketing DC Score" },
    { header: "Organic DQ", accessor: "Organic DQ" },
  ];

  const handleClose = () => {
    setShow((prevShow) => !prevShow);
  };
  const handleShowModal = () => {
    setShow(true);
  };

  const updateMetricData = async () => {
    setAddMetricLoading(true);
    try {
      const reqPayload = {
        metrics: selectedAddMetricList.map((metric) => ({
          id: metric.value,
          platform_id: metric.platform_id,
          section_id: metric.section_id,
          weights: metric.weights,
        })),
      };
      const res = await updateProject(projectId, reqPayload);

      if (res) {
        setAddMetricLoading(false);

        fetchProjectDetails({ projectId });
        handleClose();
      }
    } catch (error) {
      setAddMetricLoading(false);
      handleClose();
    }
  };

  const recentProjectId = useSelector(
    (state) => state.user.recentlyUsedProjectId
  );

  const keys = Array.from(new Set(normalizedValue.flatMap(Object.keys)));
  const keysToDisplay = keys?.slice(2);

  function getColorScore(value, thresholds) {
    // thresholds is expected to be an array with three elements: [redThreshold, yellowThreshold, greenThreshold]
    if (typeof value === "") {
      return <span style={{ color: "#252627" }}>{value}</span>;
    } else if (value > thresholds[2]) {
      return <span style={{ color: "#339900" }}>{value}</span>;
    } else if (value > thresholds[1] && value < thresholds[2]) {
      return <span style={{ color: "#ed8b00" }}>{value}</span>;
    } else {
      return <span style={{ color: "#cc3201" }}>{value}</span>;
    }
  }

  const getColor = (section) => {
    switch (section) {
      case "Marketplace":
        return "#2A61DD";
      case "Digital Spends":
        return "#279E70";
      case "Socialwatch":
        return "#FF9800";
      case "Organic Performance":
        return "#C82519";
      default:
        return "#000000";
    }
  };

  const handleCheckboxChange = async (event, metric, type) => {
    const isChecked = event.target.checked;
    setMetrics((prev) =>
      prev.map((ele) =>
        ele?.metric_id === metric?.metric_id ? { ...ele, isLoading: true } : ele
      )
    );
    if (isChecked) {
      // If the checkbox is checked, make the API call
      const analysis_type =
        type === "overall" ? "Overall" : projectDetails?.categories;
      const reqPayload = {
        platform: metric?.platform?.name,
        metrics: metric?.metric_id,
        brand: projectDetails?.brands,
        analysis_type: analysis_type,
        start_date: projectDetails?.start_date,
        end_date: projectDetails?.end_date,
      };

      try {
        const benchmarks = await getBenchmarkValues(reqPayload);

        setMetrics((prev) =>
          prev.map((ele) => {
            if (ele?.metric_id === metric?.metric_id) {
              if (type === "overall") {
                return {
                  ...ele,
                  isOverallChecked: true,
                  isCategoryBasedChecked: false,
                  benchmark: benchmarks.results,
                  isLoading: false,
                };
              } else if (type === "categoryBased") {
                return {
                  ...ele,
                  isCategoryBasedChecked: true,
                  isOverallChecked: false,
                  benchmark: benchmarks.results,
                  isLoading: false,
                };
              }
            }
            return ele;
          })
        );
      } catch (error) {
        console.error("Error in fetching benchmark values:", error);
        setMetrics((prev) =>
          prev.map((ele) =>
            ele.metric_id === metric.metric_id
              ? { ...ele, isLoading: false }
              : ele
          )
        );
      }
    } else {
      // If the checkbox is unchecked, just reset the values
      setMetrics((prev) =>
        prev.map((ele) => {
          if (ele.metric_id === metric.metric_id) {
            return {
              ...ele,
              isOverallChecked:
                type === "overall" ? false : ele.isOverallChecked,
              isCategoryBasedChecked:
                type === "categoryBased" ? false : ele.isCategoryBasedChecked,
              benchmark: null,
              isLoading: false,
            };
          }
          return ele;
        })
      );
    }
  };

  const handleSelectAll = async (e, type) => {
    const isChecked = e.target.checked;

    setLoading(true);

    if (isChecked) {
      const analysis_type =
        type === "overall" ? "Overall" : projectDetails?.categories;

      // Group metrics by platform
      const platformGroups = metrics.reduce((acc, metric) => {
        const platform = metric?.platform?.name;
        if (!acc[platform]) acc[platform] = [];
        acc[platform].push(metric);
        return acc;
      }, {});

      let cumulativeMetrics = [...metrics]; // To track updated state after each platform response

      for (const [platform, groupMetrics] of Object.entries(platformGroups)) {
        const metricIds = groupMetrics.map((m) => m?.metric_id);

        const reqPayload = {
          platform,
          metrics: metricIds,
          brand: projectDetails?.brands,
          analysis_type,
          start_date: projectDetails?.start_date,
          end_date: projectDetails?.end_date,
        };

        try {
          const response = await getBenchmarkValues(reqPayload);
          const benchmarkMap = {};

          response?.results?.forEach((item) => {
            const key = `${item.platform}|${item.metric}`;
            if (!benchmarkMap[key]) {
              benchmarkMap[key] = [];
            }
            benchmarkMap[key].push(item);
          });

          // Update the relevant metrics in the cumulative list
          cumulativeMetrics = cumulativeMetrics.map((metric) => {
            if (metric?.platform?.name === platform) {
              const key = `${metric?.platform?.name}|${metric?.metric_new_name}`;
              const benchmarks = benchmarkMap[key] || [];
              return {
                ...metric,
                isOverallChecked: type === "overall",
                isCategoryBasedChecked: type === "categoryBased",
                benchmark: benchmarks.length ? benchmarks : null,
                error: benchmarks.length === 0,
              };
            }
            return metric;
          });

          setMetrics([...cumulativeMetrics]); // Reflect changes in UI after this batch
        } catch (error) {
          console.error(
            `Error fetching benchmarks for platform: ${platform}`,
            error
          );

          // Mark errors only for the current platform
          cumulativeMetrics = cumulativeMetrics.map((metric) => {
            if (metric?.platform?.name === platform) {
              return {
                ...metric,
                error: true,
              };
            }
            return metric;
          });

          setMetrics([...cumulativeMetrics]); // Reflect error in UI for this batch
        }
      }
    } else {
      const resetMetrics = metrics.map((metric) => ({
        ...metric,
        isOverallChecked: type === "overall" ? false : metric.isOverallChecked,
        isCategoryBasedChecked:
          type === "categoryBased" ? false : metric.isCategoryBasedChecked,
        benchmark: null,
        error: false,
      }));

      setMetrics(resetMetrics);
    }

    setLoading(false);
  };

  const handleWeightChange = (metricId, value) => {
    const numericValue = isNaN(Number(value)) ? 0 : Number(value);

    // Doing a deep copy so the object referenced for weights won't be changed
    const copiedMetrics = JSON.parse(JSON.stringify(metrics));

    const editedMetrics = copiedMetrics.map((item) => {
      if (item.metric_id === metricId) {
        item.weights = numericValue;
      }
      return item;
    });

    const countNullMetrics = editedMetrics.reduce((acc, item) => {
      return acc + (item.weights === null);
    }, 0);

    const totalWeightSetManually = editedMetrics.reduce((acc, item) => {
      return acc + (item.weights === null ? 0 : item.weights);
    }, 0);

    const remainingWeight = 100 - totalWeightSetManually;

    if (remainingWeight < 0) {
      toast.warning("Total weights exceed 100. Please adjust the values.");
      return;
    } else {
      const updatedEquallyDistributedWeight =
        remainingWeight / countNullMetrics;

      setMetrics(editedMetrics);

      setEquallyDistributedWeight(updatedEquallyDistributedWeight);

      setTotalWeights(() => {
        return (
          totalWeightSetManually +
          countNullMetrics * updatedEquallyDistributedWeight
        );
      });

      setDraftMetricWeights((currentDraftMetrics) => ({
        ...currentDraftMetrics,
        [metricId]: numericValue,
      }));
    }
  };

  const handleSaveMetricsWeightsDraft = async () => {
    try {
      const updateMetricsWeightsPayload = {
        metrics: Object.entries(draftMetricWeights).map((metric) => ({
          id: Number(metric[0]),
          weights: metric[1],
        })),
      };

      const response = await updateMetricWeights(
        projectId,
        updateMetricsWeightsPayload
      );
      if (response) {
        toast.success("Weights updated successfully");
      }
    } catch (error) {
      toast.error("Failed to update weights:", error);
    }
  };

  async function fetchProjectDetails({ projectId, savingWeights = false }) {
    try {
      const response = await getProjectDetailsByProjectId(projectId);
      setProjectDetails(response?.project);
      const {
        uniqueCategoriesArray,
        uniqueBrandsArray,
        uniqueSectionsArray,
        uniquePlatformsArray,
        uniqueMetricsArray,
      } = extractUniqueValues(response?.project?.metrics);
      setFilterCategories(uniqueCategoriesArray);
      setCompareFilterCategories(uniqueCategoriesArray);
      setBrandFilterOptions(uniqueBrandsArray);
      setFilterSection(uniqueSectionsArray);
      setFilterPlatforms(uniquePlatformsArray);
      setFilterMetrics(uniqueMetricsArray);
      setMetrics(() => {
        if (
          response?.project?.metrics &&
          response?.project?.metrics?.length > 0
        ) {
          const initialWeights = response?.project?.metrics?.reduce(
            (acc, item) => {
              acc[item.metric_id] = item.weights;
              return acc;
            },
            {}
          );

          setDefaultWeights(initialWeights);
        }
        return response?.project?.metrics?.map((ele) => {
          ele.isOverallChecked = false;
          ele.isCategoryBasedChecked = false;
          return ele;
        });
      });
      // Initializing the default weights
      if (
        response?.project?.metrics &&
        response?.project?.metrics?.length > 0
      ) {
        const metricsInResponse = response?.project?.metrics;
        const countNullMetrics = metricsInResponse.reduce((acc, item) => {
          return acc + (item.weights === null);
        }, 0);
        const totalWeightSetManually = metricsInResponse.reduce((acc, item) => {
          return acc + (item.weights === null ? 0 : item.weights);
        }, 0);
        const remainingWeight = 100 - totalWeightSetManually;
        const updatedEquallyDistributedWeight =
          remainingWeight / countNullMetrics;
        setEquallyDistributedWeight(updatedEquallyDistributedWeight);
      }
      setCheckStates(
        response?.project?.metrics?.reduce((acc, item) => {
          acc[item.id] = { overall: false, categoryBased: false };
          return acc;
        }, {}) || {}
      );
      if (response?.project?.is_benchmark_saved) {
        const compareNormalizeValue = await fetchComparedValue({
          projectId,
          savingWeights,
        });
        const dqScoreValueResponse = await fetchDQScoreValue(projectId);
        if (compareNormalizeValue && dqScoreValueResponse) {
          setComparisonData(compareNormalizeValue);
          setDQScoreValue(dqScoreValueResponse);
          setDQScoreLoading(false);
        }

        return { compareNormalizeValue, dqScoreValueResponse };
      }
    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  }

  async function fetchComparedValue({ projectId, savingWeights = false }) {
    const project_id = projectId;

    const requestPayload = {
      project_ids: [project_id],
    };

    try {
      const compareNormalizeValue = savingWeights
        ? await saveAndGetNormalizedValues(requestPayload)
        : await getNormalizedValues(requestPayload);

      if (compareNormalizeValue) {
        setComparisonData(compareNormalizeValue);

        const uniqueData = transformComparisonViewApiData(
          compareNormalizeValue
        );
        const uniqueComparisonBrandNames = Array.from(
          new Set(compareNormalizeValue.map((item) => item.brandName))
        );
        const brandCategoryMap = compareNormalizeValue.reduce((acc, item) => {
          acc[item.brandName] = item.categoryName;
          return acc;
        }, {});
        setUniqueComparisonBrandName(uniqueComparisonBrandNames);
        setNormalizedValue(uniqueData);
        setBrandCategoryMap(brandCategoryMap);
      }

      return compareNormalizeValue;
    } catch (error) {
      console.error("Error in Fetching Data:", error);
    }
  }

  const transformComparisonViewApiData = (data) => {
    const transformedData = {};

    data?.forEach((item) => {
      const {
        sectionName,
        platformName,
        metricName,
        brandName,
        normalized,
        benchmarkValue,
        percentile,
      } = item;

      // Initialize section level
      if (!transformedData[sectionName]) {
        transformedData[sectionName] = {};
      }

      // Initialize platform level under the section
      if (!transformedData[sectionName][platformName]) {
        transformedData[sectionName][platformName] = {};
      }

      // Initialize metric level under the platform
      if (!transformedData[sectionName][platformName][metricName]) {
        transformedData[sectionName][platformName][metricName] = {
          platformName: platformName,
          metricName: metricName,
          brands: {},
        };
      }

      transformedData[sectionName][platformName][metricName].brands[brandName] =
        {
          normalized,
          benchmarkValue,
          percentile,
        };
    });

    const result = [];
    // Iterate over sections, platforms, and metrics to build the final result
    Object.keys(transformedData).forEach((section) => {
      Object.keys(transformedData[section]).forEach((platform) => {
        Object.keys(transformedData[section][platform]).forEach((metric) => {
          const row = {
            sectionName: section,
            platformName: platform,
            metricName: metric,
            ...transformedData[section][platform][metric].brands,
          };
          result.push(row);
        });
      });
    });

    return result;
  };

  async function fetchDQScoreValue(id) {
    const project_id = id;

    const requestPayload = {
      project_id: project_id,
    };

    try {
      const dqScoreValueResponse = await getDQScore(requestPayload);
      if (dqScoreValueResponse) {
        setDQScoreLoading(false);
        setDQScoreValue(dqScoreValueResponse?.data);
      }
      return dqScoreValueResponse?.data;
    } catch (error) {
      setDQScoreLoading(false);
      console.error("Error in Fetching Data:", error);
    }
  }

  const removeMetricsFromDB = async (metricid, metricname) => {
    try {
      const response = await removeMetricFromProject(projectId, metricid);
      if (response) {
        toast.success(`${metricname} removed successfully!!`);
        fetchProjectDetails({ projectId });
      }
    } catch (error) {
      toast.error(`Failed to remove ${metricname}!!`);
    }
  };

  const saveUserProjectDQScore = async (cmpData, dqVal) => {
    try {
      const data = constructDQScorePayload(dqVal, cmpData);
      console.log(data, "data......");
      const projectDQScore = await createUserProjectDQScore(data);
      if (projectDQScore) {
        toast.success("DC Scores are saved in DB.");
      }
    } catch (error) {
      toast.error("Failed to save DC score in DB.");
    }
  };

  const constructDQScorePayload = (dqScoreBasedOnBrandName, benchmarkValue) => {
    const payload = [];

    dqScoreBasedOnBrandName.forEach((dqScore) => {
      // Find matching benchmark data for the brand
      const brandBenchmarks = benchmarkValue?.filter(
        (benchmark) => benchmark?.brandName === dqScore?.Brand_Name
      );

      // For each section in the benchmark value, create a payload object
      // Todo: create a function to consider names in both upper & lowercase
      // Todo: also spacing if we can remove ?
      brandBenchmarks.forEach((benchmark) => {
        const scoreData = {
          user_id: userInfo?.user?.id,
          project_id: benchmark.project_id,
          brand_id: benchmark.brand_ids,
          brand_name: dqScore.Brand_Name,
          section_name: benchmark.sectionName,
          section_id: benchmark.sectionid,
          category_id: benchmark.categoryid,
          category_name: benchmark.categoryName,
          dq: dqScore.Overall_Final_Score,
          ecom_dq: dqScore.Marketplace,
          social_dq: dqScore["Digital Spends"],
          paid_dq: dqScore["Socialwatch"],
          brand_perf_dq: dqScore["Organic Performance"],
        };

        payload.push(scoreData);
      });
    });

    return payload;
  };

  const fetchSections = async () => {
    const sectionsData = await getAllSections();
    const uniqueSections = sectionsData.data.filter(
      (section, index, self) =>
        index === self.findIndex((s) => s?.name === section?.name)
    );
    setSectionsList(
      uniqueSections.map((section) => ({
        value: section?.id,
        label: section?.name,
      }))
    );
  };

  useEffect(() => {
    fetchSections();

    if (projectId) {
      setProjectIds(projectId);
      fetchProjectDetails({ projectId });
    }
  }, [projectId]);

  function extractUniqueValues(data) {
    const sectionsArray = data?.map((metric) => ({
      value: metric?.section?.id,
      label: metric?.section?.name,
    }));

    const platformsArray = data?.map((metric) => ({
      value: metric?.platform?.id,
      label: metric?.platform?.name,
    }));

    const brandsArray = data?.flatMap((metric) =>
      metric.brands.map((brand) => ({
        value: brand?.id,
        label: brand?.name,
      }))
    );

    const categoriesArray = data?.flatMap((metric) =>
      metric.categories.map((category) => ({
        value: category?.id,
        label: category?.name,
      }))
    );

    const metricsArray = data?.map((metric) => ({
      value: metric?.metric_id,
      label: metric?.metric_new_name,
    }));

    const uniqueSectionsArray = [
      ...new Map(sectionsArray?.map((item) => [item.label, item])).values(),
    ];
    const uniquePlatformsArray = [
      ...new Map(platformsArray?.map((item) => [item.label, item])).values(),
    ];
    const uniqueBrandsArray = [
      ...new Map(brandsArray?.map((item) => [item.label, item])).values(),
    ];
    const uniqueCategoriesArray = [
      ...new Map(categoriesArray?.map((item) => [item.label, item])).values(),
    ];
    const uniqueMetricsArray = [
      ...new Map(metricsArray?.map((item) => [item.label, item])).values(),
    ];

    return {
      uniqueSectionsArray: uniqueSectionsArray,
      uniquePlatformsArray: uniquePlatformsArray,
      uniqueBrandsArray: uniqueBrandsArray,
      uniqueCategoriesArray: uniqueCategoriesArray,
      uniqueMetricsArray: uniqueMetricsArray,
    };
  }

  useEffect(() => {
    if (comparisonData.length > 0) {
      setFilteredComparisonData(comparisonData);
    }
  }, [comparisonData]);

  const filterComparisonData = (selectedCategories, selectedBrands) => {
    const selectedCategoryIds = selectedCategories.map(
      (option) => option.value
    );
    const selectedBrandIds = selectedBrands.map((option) => option.value);

    // Filter the data based on selected categories and brands
    const filteredData = comparisonData.filter((item) => {
      const matchesCategory =
        selectedCategoryIds.length === 0 ||
        selectedCategoryIds.includes(Number(item.categoryid));
      const matchesBrand =
        selectedBrandIds.length === 0 ||
        selectedBrandIds.includes(Number(item.brand_ids));
      return matchesCategory && matchesBrand;
    });

    // Remove duplicates by unique combination of relevant fields
    const uniqueData = Array.from(
      new Map(
        filteredData.map((item) => [
          `${item.categoryid}-${item.brand_ids}-${item.metricname}`, // Unique key
          item,
        ])
      ).values()
    );

    setFilteredComparisonData(uniqueData);
  };

  // const filterComparisonData = (selectedCategories, selectedBrands) => {
  //   const selectedCategoryIds = selectedCategories.map((option) => option.value);
  //   const selectedBrandIds = selectedBrands.map((option) => option.value);

  //   const filteredData = comparisonData.filter((item) => {
  //     const matchesCategory = selectedCategoryIds.length === 0 || selectedCategoryIds.includes(Number(item.categoryid));
  //     const matchesBrand = selectedBrandIds.length === 0 || selectedBrandIds.includes(Number(item.brand_ids));
  //     return matchesCategory && matchesBrand;
  //   });

  //   setFilteredComparisonData(filteredData);
  // };

  // const handleCompareFilterCategory = (selectedOptions) => {
  //   setCompareSelectedFilterCategories(selectedOptions);

  //   if (selectedOptions.length > 0) {

  //     const selectedCategoryIds = selectedOptions.map((option) => option.value);

  //     const filteredData = comparisonData.filter((item) =>
  //       selectedCategoryIds.includes(Number(item.categoryid))
  //     );

  //     setFilteredComparisonData(filteredData);
  //   } else {

  //     setFilteredComparisonData(comparisonData);
  //   }
  // };

  // const handleFilterCategory = async (selectedOptions) => {
  //   setSelectedFilterCategories(selectedOptions);

  //   if (selectedOptions.length > 0) {
  //     try {
  //       const categoryIds = selectedOptions.map((option) => option.value);

  //       const getCatIds = await getAllCategories(categoryIds);
  //       const selectedCategorieIds = getCatIds?.data.map((category) => ({
  //         value: category.id,
  //         label: category.name,
  //       }));
  //       console.log("Fetched Categories:", getCatIds?.data);

  //       setFilterCategories(() => [...selectedCategorieIds]);

  //       setComparisonData((prevComparisonData) => {
  //         if (prevComparisonData && prevComparisonData.length > 0) {
  //           return prevComparisonData.filter((item) =>
  //             categoryIds.includes(item.categoryid)
  //           );
  //         }
  //          console.log("Previous Comparison Data:", prevComparisonData);
  //         return [];
  //       });
  //     } catch (error) {
  //       console.error("Error fetching categories:", error);
  //     }
  //   } else {

  //     setFilterCategories([]);
  //     fetchProjectDetails();
  //   }
  // };

  const handleFilterCategory = async (selectedOptions) => {
    setSelectedFilterCategories(selectedOptions);
    if (selectedOptions.length > 0) {
      try {
        const categoryIds = selectedOptions.map((option) => option.value);
        const getCatIds = await getAllCategories(categoryIds);
        const selectedCategorieIds = getCatIds?.data.map((category) => ({
          value: category?.id,
          label: category?.name,
        }));
        setFilterCategories((prevCategories) => {
          return [...selectedCategorieIds];
        });
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    }
  };

  const handleSelectedSection = async (selectedOptions) => {
    try {
      setSelectedFilterSection(selectedOptions);

      const existingValues = selectedOptions.map((option) => option.value);

      const platformsIDs = await getAllPlatformsBySectionIds(existingValues);

      const filteredPlatforms = platformsIDs?.data.map((sec) => ({
        value: sec.platformId,
        label: sec.platformName,
      }));

      setFilterPlatforms((prevPlatforms) => {
        return [...filteredPlatforms];
      });
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  const handleSelectedPlatforms = async (selectedOptions) => {
    try {
      setSelectedFilterPlatforms(selectedOptions);

      const existingValues = selectedOptions.map((option) => option.value);

      const metricsData = await getAllMetricsByPlatformId(existingValues);

      const filteredMetrics = metricsData?.data.map((metric) => ({
        value: metric?.id,
        label: metric?.new_name,
      }));

      setFilterMetrics((prevFilteredMetrics) => {
        return [...filteredMetrics];
      });
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  const handleSelectedMetrics = async (selectedOptions) => {
    try {
      const existingValues = selectedOptions.map((option) => option.value);
      setSelectedFilterMetrics(selectedOptions);
    } catch (error) {
      console.error("Error fetching metrics:", error);
    }
  };

  const setWeightsValueToZero = () => {
    setMetrics((oldMetrics) => {
      return oldMetrics.map((oldMetric) => {
        return {
          ...oldMetric,
          weights: 0,
        };
      });
    });
    setTotalWeights(0);
  };

  const resetWeightsValue = () => {
    const updatedMetrics = metrics.map((oldMetric) => {
      return {
        ...oldMetric,
        weights: defaultWeights[oldMetric.metric_id],
      };
    });
    const countNullMetrics = updatedMetrics.reduce((acc, item) => {
      return acc + (item.weights === null);
    }, 0);
    const totalWeightSetManually = updatedMetrics.reduce((acc, item) => {
      return acc + (item.weights === null ? 0 : item.weights);
    }, 0);
    const remainingWeight = 100 - totalWeightSetManually;
    const updatedEquallyDistributedWeight = remainingWeight / countNullMetrics;
    setTotalWeights(() => {
      return (
        totalWeightSetManually +
        countNullMetrics * updatedEquallyDistributedWeight
      );
    });
    setEquallyDistributedWeight(updatedEquallyDistributedWeight);
    setMetrics((oldMetrics) => {
      return oldMetrics.map((oldMetric) => {
        return {
          ...oldMetric,
          weights: defaultWeights[oldMetric.metric_id],
        };
      });
    });
  };

  const saveWeights = async () => {
    const saveMetricsPayload = generateApiPayload(metrics);

    try {
      const response = await saveMetricsOfProject(saveMetricsPayload);
      if (response && response.status === "success") {
        toast.success("Weights saved successfully!");
        const data = await fetchProjectDetails({
          projectId,
          savingWeights: true,
        });
        if (
          data?.compareNormalizeValue?.length > 0 &&
          data?.dqScoreValueResponse.length > 0
        ) {
          await saveUserProjectDQScore(
            data?.compareNormalizeValue,
            data?.dqScoreValueResponse
          );
        }
      }
    } catch (error) {
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data.message ===
          "Project Benchmark has already been saved, you cannot create another instance."
      ) {
        toast.error(
          "Error: Project Benchmark has already been added, you cannot create another instance."
        );
      } else {
        alert("An error occurred!");
      }
    }
  };

  const generateApiPayload = (metrics) => {
    const project_id = projectId;

    return metrics?.map((metric) => {
      const categoryIds =
        metric?.categories?.map((category) => category?.id) || [];

      const benchmarkData = metric?.categories?.map((category) => {
        const matchedBenchmark =
          metric?.benchmark?.find(
            (bm) =>
              bm?.categories?.includes(category?.name) ||
              bm?.category === "Overall"
          ) || {};

        if (metric?.isOverallChecked) {
          return {
            categoryId: category?.id,
            categoryName: category?.name,
            sectionName: metric?.section?.name,
            sectionId: metric?.section?.id,
            percentile: matchedBenchmark?.percentile,
            overallValue: matchedBenchmark?.value,
            actualValue: matchedBenchmark?.actualValue,
          };
        } else {
          return {
            categoryId: category?.id,
            categoryName: category?.name,
            sectionName: metric?.section?.name,
            sectionId: metric?.section?.id,
            percentile: matchedBenchmark?.percentile,
            benchmarkValue: matchedBenchmark?.value,
            actualValue: matchedBenchmark?.actualValue,
          };
        }
      });

      if (benchmarkData) {
        return {
          project_id: project_id,
          sectionId: metric?.section?.id || null,
          platformId: metric?.platform?.id || null,
          isOverall: metric?.isOverallChecked || false,
          isCategory: metric?.isCategoryBasedChecked || false,
          metricId: metric?.metric_id || null,
          weights:
            metric?.weights !== null
              ? metric?.weights
              : equallyDistributedWeight,
          categoryIds: categoryIds,
          brandIds: metric?.brands?.map((brand) => brand?.id) || [],
          benchmarks: JSON.stringify(benchmarkData),
        };
      }
    });
  };

  const checkAllMetricsCheckboxSelected = () => {
    if (metrics.length > 0) {
      return metrics.every(
        (item) => item.isOverallChecked || item.isCategoryBasedChecked
      );
    }
    return false;
  };

  const handleExportAnalytics = async () => {
    if (projectDetails) {
      setExcelClick(true);
    }
  };

  const kpiStructuredData = useMemo(() => {
    const brandNames = projectDetails?.brands
      ?.sort((a, b) => a.localeCompare(b))
      ?.map((brandItem, index) => brandItem);
    if (brandNames) {
      const headers = ["Section", "Platform", "Metric", ...brandNames];

      const groupedData = comparisonData?.reduce((acc, item) => {
        if (!acc[item.metricname]) acc[item.metricname] = {};
        acc[item.metricname][item.brandName] = item;
        return acc;
      }, {});

      const data = Object.keys(groupedData).map((metricName, metricIndex) => {
        const metricData = groupedData[metricName];

        return [
          metricData[Object.keys(metricData)[0]]?.sectionName,
          metricData[Object.keys(metricData)[0]]?.platformname,
          metricName,
          ...brandNames?.map((brandItem, brandIndex) => {
            const brandData = metricData[brandItem];
            return brandData?.actualValue !== null && brandData?.actualValue
              ? formatDecimalToFixed2(brandData?.actualValue)
              : "-";
          }),
        ];
      });
      return [headers, ...sortAOABySection(data)];
    }
  }, [projectDetails?.brands, comparisonData]);

  const comparisonStructuredData = useMemo(() => {
    const brandNames = projectDetails?.brands
      ?.sort((a, b) => a.localeCompare(b))
      ?.map((brandItem, index) => brandItem);
    if (brandNames) {
      const headers = ["Section", "Platform", "Metric", ...brandNames];

      const groupedData = comparisonData?.reduce((acc, item) => {
        if (!acc[item.metricname]) acc[item.metricname] = {};
        acc[item.metricname][item.brandName] = item;
        return acc;
      }, {});

      const data = Object.keys(groupedData).map((metricName, metricIndex) => {
        const metricData = groupedData[metricName];

        return [
          metricData[Object.keys(metricData)[0]]?.sectionName,
          metricData[Object.keys(metricData)[0]]?.platformname,
          metricName,
          ...brandNames?.map((brandItem, brandIndex) => {
            const brandData = metricData[brandItem];
            return brandData?.normalized !== null && brandData?.normalized
              ? Number(brandData?.normalized)
              : "-";
          }),
        ];
      });
      return [headers, ...sortAOABySection(data)];
    }
  }, [projectDetails?.brands, comparisonData]);

  useEffect(() => {
    if (excelClick) {
      if (
        dqScoreValue.length > 0 &&
        kpiStructuredData.length > 1 && // 1st row is headers
        comparisonStructuredData.length > 1
      ) {
        const workbook = generateExcel(
          dqScoreValue,
          kpiStructuredData,
          comparisonStructuredData
        );
        XLSX.writeFile(workbook, "Analytics.xlsx");
        setExcelClick(false);
      }
    }
  }, [excelClick, dqScoreValue, kpiStructuredData, comparisonStructuredData]);

  const restructureDataForBrandAsHeader = (data) => {
    if (!data || data.length === 0) return [];

    const rowHeaders = Array.from(
      new Set(
        data.map((item) => `${item.section}-${item.platform}-${item.metric}`)
      )
    );

    const brands = Array.from(new Set(data.map((item) => item.brand)));

    const structuredData = rowHeaders.map((header) => {
      const [section, platform, metric] = header.split("-");
      return [section, platform, metric, ...brands.map(() => "")];
    });

    data.forEach((item) => {
      const rowIndex = rowHeaders.indexOf(
        `${item.section}-${item.platform}-${item.metric}`
      );
      const brandIndex = brands.indexOf(item.brand);

      // Check if rowIndex or brandIndex is not found
      if (rowIndex === -1) {
        console.error(
          `Row header not found for: ${item.section}-${item.platform}-${item.metric}`
        );
        return; // Skip this item if the header is not found
      }

      if (brandIndex === -1) {
        console.error(`Brand not found for: ${item.brand}`);
        return; // Skip this item if the brand is not found
      }

      structuredData[rowIndex][3 + brandIndex] = item.result; // Fill in the result for the brand
    });

    // Prepend headers to the data (Section, Platform, Metric, followed by brands)
    return [["Section", "Platform", "Metric", ...brands], ...structuredData];
  };

  const generateExcel = (
    dqScoreData,
    kpiStructuredData,
    comparisonScoreData
  ) => {
    const workbook = XLSX.utils.book_new();

    const dqWorksheet = XLSX.utils.json_to_sheet(dqScoreData);
    const kpiWorksheet = XLSX.utils.aoa_to_sheet(kpiStructuredData);
    const comparisonWorksheet = XLSX.utils.aoa_to_sheet(comparisonScoreData);

    XLSX.utils.book_append_sheet(workbook, dqWorksheet, "DC Score");
    XLSX.utils.book_append_sheet(workbook, kpiWorksheet, "KPI Score");
    XLSX.utils.book_append_sheet(
      workbook,
      comparisonWorksheet,
      "Comparison View"
    );
    return workbook;
  };

  const handleAddSection = async (selectedOptions) => {
    setSelectedSectionsList(selectedOptions);
    if (selectedOptions.length > 0) {
      try {
        const sectionIDs = selectedOptions.map((option) => option.value);
        const platformsIDs = await getAllPlatformsBySectionIds(sectionIDs);
        setPlatformsList(
          platformsIDs.data.map((sec) => ({
            value: sec.platformId,
            label: sec.platformName,
          }))
        );
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    }
  };

  const handleAddPlatform = async (selectedOptions) => {
    setSelectedPlatformsList(selectedOptions);

    if (selectedOptions.length > 0) {
      try {
        const platformIds = selectedOptions.map((option) => option.value);
        const metricsData = await getAllMetricsByPlatformId(platformIds);
        setAddMetricList(
          metricsData.data.map((metric) => ({
            value: metric?.id,
            label: metric?.new_name,
            platform_id: metric?.platform_id,
            section_id: metric?.section_id,
            weights: 0,
          }))
        );
      } catch (error) {
        console.error("Error fetching metrics:", error);
      }
    }
  };
  const handleAddMetric = (selectedOptions) => {
    setAddSelectedMetricList(selectedOptions);
  };

  const tabs = [
    {
      label: "Weights and Benchmark",
      content: (
        <div>
          <div className="row">
            <div className="col12">
              <div className="table-buttons">
                <ButtonComponent
                  btnClass={"btn-secondary"}
                  disabled={projectDetails?.is_benchmark_saved}
                  btnName={"Set weights as 0"}
                  onClick={setWeightsValueToZero}
                />
                <ButtonComponent
                  btnClass={"btn-secondary"}
                  disabled={projectDetails?.is_benchmark_saved}
                  btnName={"Reset"}
                  onClick={resetWeightsValue}
                />
                <ButtonComponent
                  btnClass={"btn-secondary"}
                  disabled={projectDetails?.is_benchmark_saved}
                  btnName={"Add Metric"}
                  onClick={handleShowModal}
                />
              </div>
            </div>
          </div>
          <AnalyticsTable
            projectDetails={projectDetails}
            checkStates={checkStates}
            metrics={metrics}
            equallyDistributedWeight={equallyDistributedWeight}
            totalWeights={totalWeights}
            handleCheckboxChange={handleCheckboxChange}
            handleSelectAll={handleSelectAll}
            handleWeightChange={handleWeightChange}
            removeMetricsFromDB={removeMetricsFromDB}
            isBenchmarkSaved={projectDetails?.is_benchmark_saved}
            selectedCategory={selectedFilterCategories}
            selectedSections={selectedFilterSection}
            selectedPlatforms={selectedFilterPlatforms}
            selectedMetrics={selectedFilterMetrics}
            isLoading={true}
          />
          <div className="row">
            <div className="col12">
              <div className="save-table-btn">
                <ButtonComponent
                  btnClass={"btn-primary"}
                  btnName={"Save As Draft"}
                  onClick={handleSaveMetricsWeightsDraft}
                />
                <ButtonComponent
                  btnClass={"btn-primary"}
                  btnName={"Save Weights"}
                  disabled={
                    projectDetails?.is_benchmark_saved ||
                    !checkAllMetricsCheckboxSelected()
                  }
                  onClick={saveWeights}
                />
              </div>
            </div>
          </div>
        </div>
      ),
    },

    {
      label: "DC Scores",
      disabled: "disabled",
      content: (
        <div>
          <ScoreCard
            dqScoreValue={dqScoreValue}
            dqScoreLoading={dqScoreLoading}
            selectedCategory={selectedFilterCategories}
            selectedSections={selectedFilterSection}
            selectedPlatforms={selectedFilterPlatforms}
            selectedMetrics={selectedFilterMetrics}
          />
        </div>
      ),
    },
    {
      label: "Graphical view",
      content: (
        <div>
          <GraphicalView
            getColor={getColor}
            projectId={projectId}
            normalizedData={comparisonData}
          />
        </div>
      ),
    },
    {
      label: "KPI Scores",
      content: (
        <>
          <KPITable
            normalizedData={comparisonData}
            metrics={metrics}
            projectDetails={projectDetails}
            getColor={getColor}
            getColorScore={getColorScore}
          />
        </>
      ),
    },

    {
      label: "Comparison View",
      content: (
        <>
          <ComparisionView
            filterComparisonData={filterComparisonData}
            brandFilterOptions={brandFilterOptions}
            filteredComparisonData={filteredComparisonData}
            compareFilterCategories={compareFilterCategories}
            getColor={getColor}
          />
        </>
      ),
    },

    {
      label: "Super Themes",
      disabled: "disabled",
      content: (
        <div>
          {normalizedValue && (
            <SuperThemes
              metrics={metrics}
              normalizedDQScoreValue={normalizedValue}
              projectId={projectId}
            />
          )}
        </div>
      ),
    },
  ];

  console.log("comparision Data", comparisonData);
  console.log("metrics", metrics);
  console.log("project", projectDetails);

  return (
    <>
      <div className="col-12">
        <div className="workspace-container">
          <h2 className="page-title">Analytics</h2>

          <div className="row mb-3">
            <div className="col-12">
              <div className="analytics-filter">
                <div className="project-details">
                  <p className="mb-0">
                    Project Name:
                    <strong>{projectDetails?.project_name}</strong>
                  </p>
                </div>

                <div className="export-share-btn-group">
                  <div className="export-btn-container gap-3">
                    <div className="export-btn">
                      <ButtonComponent
                        btnClass={"btn-primary export-excel-btn"}
                        btnName={"Export as Excel"}
                        onClick={handleExportAnalytics}
                      />
                    </div>
                  </div>
                  <div className="export-btn-container">
                    <div className="export-btn">
                      <ButtonComponent
                        btnClass={"btn-primary export-excel-btn"}
                        btnName={"Share via Email"}
                        onClick={handleShareViaEmailClick}
                      />
                      <ShareViaEmailDialog
                        generateExcel={() => generateExcel(dqScoreValue, kpiStructuredData, comparisonStructuredData )}
                        open={shareDialogOpen}
                        onClose={handleCloseShareDialog}
                        fileName="Analytics.xlsx"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 analytics-select">
              <MultiSelectDropdown
                options={filterCategories}
                selectedValues={selectedFilterCategories}
                onChange={handleFilterCategory}
                placeholder="Select Category"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 analytics-select">
              <MultiSelectDropdown
                options={filterSection}
                selectedValues={selectedFilterSection}
                onChange={handleSelectedSection}
                placeholder="Select Section"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 analytics-select">
              <MultiSelectDropdown
                options={filterPlatforms}
                selectedValues={selectedFilterPlatforms}
                onChange={handleSelectedPlatforms}
                placeholder="Select Platforms"
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 analytics-select">
              <MultiSelectDropdown
                options={filterMetrics}
                selectedValues={selectedFilterMetrics}
                onChange={handleSelectedMetrics}
                placeholder="Select Metrics"
              />
            </div>

            <div className="col-12">
              <TabComponent
                tabs={tabs}
                isBenchmarkDataSaved={projectDetails?.is_benchmark_saved}
                className="analytics-tabs"
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="modal-height"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Metrics</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-5">
          <div className="row">
            <div className="col-lg-4 col-md-6 ws-select">
              <MultiSelectDropdown
                options={sectionsList}
                selectedValues={selectedSectionsList}
                onChange={handleAddSection}
                placeholder="Select Section"
              />
            </div>
            <div className="col-lg-4 col-md-6 ws-select">
              <MultiSelectDropdown
                options={platformsList}
                selectedValues={selectedPlatformsList}
                onChange={handleAddPlatform}
                placeholder="Select Platforms"
              />
            </div>
            <div className="col-lg-4 col-md-6 ws-select">
              <MultiSelectDropdown
                options={addMetricList}
                selectedValues={selectedAddMetricList}
                onChange={handleAddMetric}
                placeholder="Select Metrics"
              />
            </div>
          </div>

          {addMetricLoading && (
            <div className="loader-container-sm">
              <div className="loader-sm"></div>
              <span className="loader-text">Loading...</span>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <ButtonComponent
            btnClass={"btn-outline-secondary"}
            btnName={"Cancel"}
            onClick={handleClose}
          />
          <ButtonComponent
            btnClass={"btn-primary px-4"}
            btnName={"Add Metric"}
            onClick={updateMetricData}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
